<!-- TODO same: src/components/texts/TableEmptyText.vue -->
<!-- TODO same: src/components/items/NoDataSelectVListItem.vue -->
<template>
  <li :class="$style.noDataListItem" data-testid="noDataListItem">
    <slot>No such data</slot>
  </li>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.noDataListItem {
  color: colors.$color-gray-600;
  padding: 15px;
  font-style: italic;
}
</style>
